"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doWeiXinLaunch = void 0;
/**
 * 微信scheme跳转
 * @param {EnumSchemeUrl} schemeUrl
 * @param {BeaconReport} reportCallback 灯塔上报回调
 * @param {WxLaunchFailedCallback} wxLaunchFailedCallback 微信唤起失败回调函数
 */
var doWeiXinLaunch = function (schemeUrl, debugMode, reportCallback, jumpCallback) {
    if (debugMode === void 0) { debugMode = false; }
    if (reportCallback) {
        reportCallback('web_do_wx_launch');
    }
    if (window.WeixinJSBridge) {
        console.log('invoking WeixinJSBridge launchApplication...');
        if (debugMode) {
            alert('invoking!!');
        }
        if (reportCallback) {
            reportCallback('web_wx_invoke_launch');
        }
        window.WeixinJSBridge.invoke('launchApplication', {
            schemeUrl: schemeUrl,
        }, function (res) {
            if (debugMode) {
                alert("invoke res:".concat(JSON.stringify(res)));
            }
            console.log('WeixinJSBridge invoke result:', res);
            if (reportCallback) {
                var resultMsg = '';
                if (res === null || res === void 0 ? void 0 : res.err_msg) {
                    resultMsg = res.err_msg;
                    jumpCallback === null || jumpCallback === void 0 ? void 0 : jumpCallback(resultMsg);
                }
                console.error(resultMsg);
            }
        });
    }
    else {
        if (reportCallback) {
            reportCallback('web_no_wxjsbridge_at_last');
        }
        if (debugMode) {
            alert('no WeixinJSBridge in doWeiXinLaunch');
        }
    }
};
exports.doWeiXinLaunch = doWeiXinLaunch;
//# sourceMappingURL=weixin-launch.js.map